'use client';

import axios, { CreateAxiosDefaults } from 'axios';
import { ROOT_URL } from '@/constants/url';

// Базовые настройки axios
const config: CreateAxiosDefaults = {
  baseURL: ROOT_URL, // Базовый URL API
  headers: {}, // Дефолтные заголовки (можно добавить общие для всех запросов)
};

// Создаем экземпляр axios с настройками
const apiAxios = axios.create(config);

// --- Response Interceptor ---
// Обрабатывает все ответы сервера и возможные ошибки
apiAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error(error);
    throw error;
  },
);

export default apiAxios;
